module.exports = __webpack_public_path__ + "c_static/img/mine_Entrance_gif_default.07cdeb3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/邀请好友/mine_Entrance_gif_default.gif
// module id = gjWk
// module chunks = 33